import { roomsApi } from "../../API/API";
import { CLEAR_ROOM, SET_IN_ROOM_FIELDS, SET_ROOM, SET_TYPE_LIST } from "./constans";
import { updateSavingStatus } from "../../globalState/app/actions";


export const setRoom = (payload) => {
  return {
    type: SET_ROOM,
    payload
  }
}

export const clearRoom = () => {
  return {
    type: CLEAR_ROOM,

  }
}

export const setTypeList = (payload) => {
  return {
    type: SET_TYPE_LIST,
    payload
  }
}


export const setInRoomFields = (payload) => {
  return {
    type: SET_IN_ROOM_FIELDS,
    payload
  }
}


const prittieAndSetRoom = (room) => async (dispatch) => {

  const roomMain = {
    active: room.active,
    type: room.type,
    count: room.count,
    area: room.area,
    id: room.id,
    name: room.name,
    adult: room.adult,
    additional: room.additional,
    child: room.child,
  }
  const photos = {
    photos: room.photos,
    rejectedPhotos: room.rejectedPhotos,
  }
  const errors = room.errors
  const inRoom = {
    meals: room.meals,
    tech: room.tech,
    facilities: room.facilities,
    bathroom: room.bathroom,
    view: room.view,
  }

  return dispatch(setRoom({ roomMain, photos, inRoom, errors }))
}


export const getRoomById = (room) => async (dispatch) => {

  let response = await roomsApi.getRoomById(room);
  if (response.status) {
    dispatch(prittieAndSetRoom(response.data))
  }
}


export const getTypeList = () => async (dispatch) => {
  let response = await roomsApi.getTypeList();
  if (response.status) {
    dispatch(setTypeList(response.data))
  }
}

export const getFields = (formValue) => async (dispatch) => {
  let response = await roomsApi.getFields(formValue);
  if (response.status) {
    return dispatch(setInRoomFields(response.data))
  }
}


export const addRoom = (formValue) => async (dispatch) => {
  dispatch(updateSavingStatus({ status: "loading" }))
  let response = await roomsApi.addRoom(formValue);
  if (response.status) {
    dispatch(updateSavingStatus({ status: "success" }))
    return response.data
  } else {
    dispatch(updateSavingStatus({ status: "error", message: response.data.message }))
  }
}

export const updateRoom = (formValue) => async (dispatch) => {
  dispatch(updateSavingStatus({ status: "loading" }))
  let response = await roomsApi.updateRoom(formValue);
  if (response.status) {
    dispatch(updateSavingStatus({ status: "success" }))
    return dispatch(prittieAndSetRoom(response.data))
  } else {
    dispatch(updateSavingStatus({ status: "error", message: response.data.message }))
  }
}
